import _taggedTemplateLiteral from "/home/alex/code/avail/ny-mitigates/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\tpadding: 0.5rem 1rem;\n\tcolor: currentColor;\n\tfont-size: 1rem;\n\tline-height: 1.5rem;\n\ttext-decoration: none;\n\t&:hover {\n\t\ttext-decoration: underline;\n\t}\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n\twidth: 1.5rem;\n\theight: 1.5rem;\n\tfill: currentColor;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n\t\t--marker-color: ", ";\n\t\t--marker-width: ", ";\n\t\t--pager-background-color: ", ";\n\t\t--pager-color: ", ";\n\t\t--pager-color-active: ", ";\n\t\t--pager-gap: ", ";\n\t\t--pager-size: ", ";\n\t\t--stroke-width: ", ";\n\t\t", ": 0;\n\t"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n\t", ";\n\n\tposition: absolute;\n\tz-index: 2;\n\ttop: 50%;\n\tmargin: 0 0.5rem;\n\ttransform: translateY(-50%);\n\tbackground-color: var(--pager-background-color);\n\tborder-radius: calc(var(--pager-size) / 2);\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\talign-content: center;\n\tjustify-content: center;\n\tmargin: calc(var(--pager-gap) * -1) -0.5rem;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\t\tcolor: var(--color);\n\t\tbackground-color: ", ";\n\t\tborder: var(--stroke-width) solid ", ";\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tbackground-color: var(--pager-color-active);\n\t\t\tborder-color: var(--marker-color);\n\t\t}\n\t\t&:focus {\n\t\t\tbox-shadow: 0 0 0 2px var(--marker-color);\n\t\t}\n\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\tposition: relative;\n\tz-index: 2;\n\theight: var(--pager-size);\n\twidth: var(--pager-size);\n\tmargin: var(--pager-gap) 0.5rem;\n\tvisibility: visible;\n\tborder-radius: 50%;\n\tdisplay: flex;\n\talign-content: center;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-align: center;\n\tcolor: currentColor;\n\ttext-decoration: none;\n\tbackground-clip: content-box;\n\n\t", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tz-index: 1;\n\ttop: calc((var(--pager-size) / 2) + var(--pager-gap));\n\tleft: calc(0.5rem + (var(--pager-size) - var(--marker-width)) / 2);\n\twidth: var(--marker-width);\n\tbackground: var(--marker-color);\n\tvisibility: visible;\n\n\t&::before,\n\t&::after {\n\t\tposition: absolute;\n\t\tcontent: \"\";\n\t\tdisplay: block;\n\t\theight: calc(var(--marker-width) / 2);\n\t\twidth: var(--marker-width);\n\t\tleft: 0;\n\t\tbackground: inherit;\n\t}\n\n\t&::before {\n\t\tbottom: 100%;\n\t\tborder-radius: calc(var(--marker-width) / 2) calc(var(--marker-width) / 2) 0 0;\n\t}\n\n\t&::after {\n\t\ttop: 100%;\n\t\tborder-radius: 0 0 calc(var(--marker-width) / 2) calc(var(--marker-width) / 2);\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { ScrollConsumer } from '@stickyroll/context';
import { light } from '@stickyroll/themes';
import { assert, scrollTo } from '@stickyroll/utils';
/**
 * @type {StyledComponent<"div", {}>}
 * @return {React.ReactHTMLElement<HTMLElement>}
 */

var StyledMarker = styled.div(_templateObject());
/**
 * @type {StyledComponent<"nav", {}>}
 * @param {IMarkerProps} props
 * @param {number} props.page
 * @param {number} props.progress
 * @return {React.ReactHTMLElement<HTMLElement>}
 */

var Marker = function Marker(props) {
  return React.createElement(StyledMarker, {
    style: {
      height: "calc(".concat(props.progress, " * (var(--pager-gap) * 2 + var(--pager-size)) + ").concat(props.page, " * (var(--pager-gap) * 2 + var(--pager-size)))")
    }
  });
};
/**
 * @type {StyledComponent<"a", {}, PagerProps>}
 * @param {PagerProps} props
 * @param {boolean} [props.active]
 * @param {boolean} [props.selected]
 * @return {React.ReactHTMLElement<HTMLAnchorElement>}
 */


var Pager = styled.a(_templateObject2(), function (props) {
  return css(_templateObject3(), props.selected ? "var(--pager-color-active)" : "var(--pager-color)", props.active ? "var(--marker-color)" : "transparent");
});
/**
 * @type {StyledComponent<"nav", {}>}
 * @return {React.ReactHTMLElement<HTMLElement>}
 */

var StyledPagers = styled.nav(_templateObject4());
/**
 * @type {StyledComponent<"nav", {}>}
 * @param {IPagerWrapperProps} props
 * @param {ITheme} [props.theme]
 * @return {React.ReactHTMLElement<HTMLElement>}
 */

var PagerWrapper = styled.div(_templateObject5(), function (props) {
  return css(_templateObject6(), props.theme.markerColor, props.theme.markerWidth, props.theme.pagerBackgroundColor, props.theme.pagerColor, props.theme.pagerColorActive, props.theme.pagerGap, props.theme.pagerSize, props.theme.strokeWidth, props.position);
});
PagerWrapper.defaultProps = {
  position: "left",
  theme: light
};
/**
 * @type {StyledComponent<"svg", {}>}
 * @return {React.ReactSVGElement<SVGSVGElement>}
 */

var Icon = styled.svg.attrs({
  viewBox: "0 0 24 24"
})(_templateObject7());
/**
 * @type {React.FunctionComponent<IPagerBaseProps>}
 * @param {ISkipBaseProps} props
 * @param {number} props.page
 * @param {number} props.pages
 * @param {string} props.prefix
 * @param {number} props.progress
 * @param {boolean} [props.showLabels]
 * @return {React.ReactHTMLElement<HTMLElement>}
 */

var PagerBase = function PagerBase(props) {
  var handleClick = function handleClick(e) {
    e.preventDefault();
    var target = e.target;
    var id = target.getAttribute("href").replace(/^#/, "");
    scrollTo(id, target);
  };

  var glue = props.prefix === "" ? "" : "/";
  return React.createElement(React.Fragment, null, React.createElement(PagerWrapper, {
    position: props.position
  }, React.createElement(StyledPagers, null, React.createElement(Marker, {
    progress: props.progress,
    page: props.pageIndex
  }), Array(props.pages).fill(Boolean).map(function (x, i) {
    var id = "".concat(props.prefix).concat(glue).concat(i + 1);
    return React.createElement(Pager, {
      key: id,
      active: i <= props.pageIndex,
      selected: i === props.pageIndex && props.progress < 1,
      href: "#".concat(id),
      onClick: handleClick
    }, props.showLabels && i + 1);
  }), React.createElement(Pager, {
    href: "#".concat(props.prefix).concat(glue).concat(props.pages + 1),
    selected: props.page === props.pages && props.progress === 1,
    active: props.page === props.pages && props.progress === 1,
    onClick: handleClick
  }, props.showLabels && React.createElement(Icon, null, React.createElement("path", {
    d: "M4,5V19L11,12M18,5V19H20V5M11,5V19L18,12"
  }))))));
};
/**
 * @type {React.FunctionComponent<IPagersProps>}
 * @param {ISkipBaseProps} props
 * @param {number} props.page
 * @param {number} props.pages
 * @param {string} props.prefix
 * @param {number} props.progress
 * @param {boolean} [props.showLabels]
 * @param {boolean} [props.useContext]
 * @return {React.ReactHTMLElement<HTMLElement>}
 */


var Pagers = function Pagers(props) {
  if (props.useContext) {
    return React.createElement(ScrollConsumer, null, function (context) {
      return React.createElement(PagerBase, {
        page: context.page,
        pageIndex: context.pageIndex,
        pages: context.pages,
        position: props.position,
        prefix: context.anchors,
        progress: context.progress,
        showLabels: props.showLabels
      });
    });
  }

  assert(props.page, "number");
  assert(props.pageIndex, "number");
  assert(props.pages, "number");
  assert(props.progress, "number");
  assert(props.prefix, "string");
  return React.createElement(PagerBase, {
    page: props.page,
    pageIndex: props.pageIndex,
    pages: props.pages,
    position: props.position,
    prefix: props.prefix,
    progress: props.progress,
    showLabels: props.showLabels
  });
};

Pagers.defaultProps = {
  position: "left"
};
/**
 * @type {StyledComponent<"a", {}>}
 * @return {React.ReactHTMLElement<HTMLAnchorElement>}
 */

var SkipLink = styled.a(_templateObject8());
/**
 * @type {React.FunctionComponent<ISkipBaseProps>}
 * @param {ISkipBaseProps} props
 * @param {string} props.prefix
 * @return {React.ReactHTMLElement<HTMLAnchorElement>}
 */

var SkipBase = function SkipBase(props) {
  var glue = props.prefix === "" ? "" : "/";

  var handleClick = function handleClick(e) {
    e.preventDefault();
    scrollTo("".concat(props.prefix).concat(glue, "skip"), e.target, {
      noFocus: true,
      noHash: true
    });
  };

  return React.createElement(SkipLink, {
    href: "#".concat(props.prefix).concat(glue, "skip"),
    onClick: handleClick
  }, "Skip");
};
/**
 * @type {React.FunctionComponent<IPagersProps>}
 * @param {ISkipBaseProps} props
 * @param {string} [props.prefix]
 * @param {boolean} [props.useContext]
 * @return {React.ReactHTMLElement<HTMLElement>}
 */


var Skip = function Skip(props) {
  if (props.useContext) {
    return React.createElement(ScrollConsumer, null, function (context) {
      return React.createElement(SkipBase, {
        prefix: context.anchors
      });
    });
  }

  assert(props.prefix, "string");
  return React.createElement(SkipBase, {
    prefix: props.prefix
  });
};

export { Pager, Icon, PagerBase, Pagers, StyledMarker, Marker, SkipLink, SkipBase, Skip };